import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useStmQuickOrderStore } from '../../../hooks'
import { type CsvButlerItem } from '../../../hooks/use-stm-quick-order-store'
import { CsvButlerListItem } from './CsvButlerListItem'
import { type CsvBrandGroup } from './group-csv-items-by-brand'

export interface CsvBrandSectionProps {
  group: CsvBrandGroup
  brandName: string
  disabled?: boolean
}

export const CsvBrandSection = ({ group, brandName, disabled = false }: CsvBrandSectionProps) => {
  const upsertCsvItem = useStmQuickOrderStore(state => state.upsertCsvItem)

  const handleQuantityChange = (item: CsvButlerItem) => (value?: number) => {
    if (value === undefined) return
    upsertCsvItem(item.key, { quantity: value })
  }

  return (
    <VStack gap={4}>
      <Text variant="subtitle" color={colors.grey800}>{brandName}</Text>
      {group.items.map(item => (
        <CsvButlerListItem
          key={item.key}
          item={item}
          disabled={disabled}
          onQuantityChange={handleQuantityChange(item)}
          onCheckboxChange={event => upsertCsvItem(item.key, { checked: event.target.checked })}
          onDelete={() => upsertCsvItem(item.key, { isDeleted: true })}
        />
      ))}
    </VStack>
  )
}
